import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Band } from './Band';
import { scenarioClasses } from '../../data/site';
export function Scenarios() {
  return <Band id="scenarios" eyebrow="Calibrated judgement" title="Four kinds of scenario. Only one contains an error." description="Six scenarios drawn from four classes, and the candidate is never told which is which. Only one class contains an error at all. The rest are difficult for the reasons real work is difficult — evidence that conflicts, evidence that is scattered, and evidence that is simply correct." data-id="element-344" data-mp="2uvxeslljo2bd">
      <div className="grid gap-4 md:grid-cols-2" data-id="element-345" data-mp="2c5xuec0nfbea">
        {scenarioClasses.map(item => <article key={item.name} className={`flex flex-col rounded-2xl border bg-white/70 p-8 lg:p-9 ${item.clean ? 'border-teal border-l-[3px] border-l-teal' : 'border-mist'}`} data-id="element-346" data-mp="2h2y20rd5cm7i">
            <span className={`font-mono text-xs uppercase tracking-[0.2em] ${item.clean ? 'text-teal' : 'text-muted'}`} data-id="element-347" data-mp="275a4jto5p0ln">
              {item.count}
            </span>
            <h3 className="mt-4 font-display text-2xl font-medium text-ink" data-id="element-348" data-mp="16fbcapwn29ey">
              {item.name}
            </h3>
            <p className="mt-4 max-w-[52ch] text-lg leading-relaxed text-graphite" data-id="element-349" data-mp="1fdwp04ffiu7t">
              {item.what}
            </p>
            <p className="mt-6 border-t border-mist pt-5 text-[15px] leading-relaxed text-ink" data-id="element-350" data-mp="1bc1qf7ovuuxq">
              <span className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-351" data-mp="nm7bmkl06wau">
                Reveals ·{' '}
              </span>
              {item.reveals}
            </p>
          </article>)}
      </div>

      <figure className="mt-6 max-w-2xl" data-id="element-352" data-mp="wg2j3z9lkytn">
        <div className="rounded-2xl border border-mist bg-white px-6 py-5" data-id="element-353" data-mp="wgvjmihyqs3c">
          <figcaption className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-354" data-mp="rmr8dn1nzxwg">
            Scenario 4 · clean case
          </figcaption>
          <p className="mt-3 font-mono text-[15px] leading-relaxed text-ink" data-id="element-355" data-mp="3w2sj1wxzlhbu">
            Over-checked. Source queried three times across 11 minutes. No
            discrepancy existed.{' '}
            <span className="text-clay" data-id="element-356" data-mp="240pquy4snd3s">Partial credit.</span>
          </p>
        </div>
        <p className="mt-4 max-w-[70ch] text-sm leading-relaxed text-muted" data-id="element-357" data-mp="28rpo64htrx6t">
          A clean case is only meaningful if the candidate could plausibly have
          doubted it. We build them to be genuinely arguable, and we report the
          cases where they were not.
        </p>
        <Link to="/methodology" className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-ink underline decoration-mist underline-offset-4 transition-colors hover:decoration-teal" data-id="element-358" data-mp="1g54u2w9yt6zk">
          See the archetypes a scenario is built from
          <ArrowRightIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-359" data-mp="1v1ce9wldi8eu" />
        </Link>
      </figure>
    </Band>;
}